module.exports = __webpack_public_path__ + "static/media/main1.ac54c737.jpg";